import React from 'react';

import { SecondaryButton } from '@rikstv/shared-components';

interface Props {
  onClick(): void;
  className?: string;
}

const MoreEpisodes: React.FunctionComponent<Props> = ({ onClick, className }) => (
  <SecondaryButton onClick={onClick} className={className}>
    Last flere episoder
  </SecondaryButton>
);

export { MoreEpisodes };
